/**
 * Бакет по количеству пинов в тайле.
 *
 * Время отрисовки линейно зависит от количества пинов, поэтому без разбивки перцентили
 * смешивают пустой тайл с плотной застройкой и не значат ничего.
 */
export function getPinsCountBucket(pinsCount: number): string {
  if (pinsCount <= 10) {
    return '1-10';
  }

  if (pinsCount <= 50) {
    return '11-50';
  }

  if (pinsCount <= 200) {
    return '51-200';
  }

  return '200-plus';
}
